import { AddressStyled } from './styles/AddressStyled'

export interface IAddressProps {
  addressOne?: string
  addressTwo?: string
  city?: string
  stateProvince?: string
  postalCode?: string
  country?: string
  singleLine?: boolean
}

export const Address = ({
  addressOne,
  addressTwo,
  city,
  stateProvince,
  postalCode,
  country,
  singleLine = false,
}: IAddressProps) => {
  const renderAddress = () => {
    const cityStateLine = []
    if (city) cityStateLine.push(`${city},`)
    if (stateProvince) cityStateLine.push(stateProvince)
    if (postalCode) cityStateLine.push(postalCode)

    let addressLines = []

    if (addressOne)
      addressLines.push(<span key='addressOne'>{addressOne}</span>)

    if (addressTwo)
      addressLines.push(<span key='addressTwo'>{addressTwo}</span>)

    if (cityStateLine.length > 0)
      addressLines.push(<span key='cityLine'>{cityStateLine.join(' ')}</span>)

    if (country) {
      addressLines.push(<span key='country'>{country}</span>)
    }

    addressLines = []
      .concat(
        ...addressLines.map((n, i) => [
          n,
          singleLine ? (
            <span key={`break-${i}`}>, </span>
          ) : (
            <br key={`break-${i}`} />
          ),
        ])
      )
      .slice(0, -1)

    return addressLines.length > 0 ? addressLines : '--'
  }

  return <AddressStyled>{renderAddress()}</AddressStyled>
}

Address.displayName = 'Address'
